import { QueryClient } from "@tanstack/react-query";
import { CommonProject } from "../types";
import { projectQueries } from "../queries";

export async function fetchProjectName(
  projectId: string | null | undefined,
  fetchProject: ({
    projectId,
  }: {
    projectId: string;
  }) => Promise<CommonProject>,
  queryClient: QueryClient
): Promise<string | undefined> {
  if (!projectId) {
    return undefined;
  }

  const project = await queryClient.fetchQuery({
    queryKey: projectQueries.get(projectId),
    queryFn: () => fetchProject({ projectId }),
  });

  return project?.name;
}
